export default "__VITE_ASSET__CAkI73t8__"